// src/mocks/handlers/packProducts.handlers.js
import * as data from '../data/packProducts.demo';

export const getStats = async () => data.stats;
export const getBrands = async () => data.brandList;
export const bulkVerify = async () => ({ success: true, results: [] });
export const refresh = async () => ({ success: true });
export const getUnifiedStockStats = async () => data.unifiedStockStats;
export const getUnifiedStock = async () => data.unifiedStock;

export const handle = async (config) => {
    if (config.method === 'post') return { success: true, data: {} };
    if (config.method === 'put') return { success: true };
    if (/\/pack-products\/\d+/.test(config.url)) return data.packDetail;
    return data.packList;
};
